import { useEffect, useState } from "react";
import api, { fileUrl } from "@/lib/api";

let _logoCache; // undefined = unknown, string = url, null = none
let _pending;

function loadLogo() {
  if (_logoCache !== undefined) return Promise.resolve(_logoCache);
  if (!_pending) {
    _pending = api.get("/content")
      .then((r) => { _logoCache = r.data.logo_lisungi || null; return _logoCache; })
      .catch(() => { _logoCache = null; return null; });
  }
  return _pending;
}

export function Logo({ variant = "light", size = "md" }) {
  const [logo, setLogo] = useState(_logoCache);
  useEffect(() => { loadLogo().then(setLogo); }, []);

  const h = size === "lg" ? "h-16" : "h-12";
  if (logo) {
    return (
      <div className="flex items-center" data-testid="brand-logo">
        <div className="bg-white rounded-lg px-2 py-1 flex items-center shadow-sm">
          <img src={fileUrl(logo)} alt="Lisungi AI" className={`${h} w-auto object-contain`} />
        </div>
      </div>
    );
  }
  const text = variant === "light" ? "text-white" : "text-navy";
  const sub = variant === "light" ? "text-white/60" : "text-muted2";
  const title = size === "lg" ? "text-3xl" : "text-xl";
  return (
    <div className="leading-none" data-testid="brand-logo">
      <div className={`font-serif font-bold ${title} ${text} tracking-tight`}>
        Lisungi<span className="text-lisungi-yellow"> AI</span>
      </div>
      <div className={`text-[10px] uppercase tracking-[0.18em] ${sub} font-mono mt-0.5`}>
        Conçu par le LARSICOM
      </div>
    </div>
  );
}
